import styled from 'styled-components';

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  padding: 12px 0;
  margin-top: 8px;
`;

export const FilterTag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e6f4fb;
  color: #0090D3;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
`;

export const RemoveButton = styled.button`
  background: none;
  border: none;
  color: #0090D3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  border-radius: 50%;
  
  &:hover {
    background-color: #0090D3;
    color: white;
  }
`;

export const ClearAllButton = styled.button`
  background: none;
  border: none;
  color: #696969;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  text-decoration: underline;
  
  &:hover {
    color: #0090D3;
  }
`;